import apiCall from "axios";
import { axios } from "../../config/axiosOutlookConfig";
import { endpoints } from "../../config/outlookConfig";

async function getUserEvents(userId, timeZone) {
  return axios
    .get(`${endpoints.calendar.getUserEvent}${userId}&timeZone=${timeZone}`)
    .then(response => {
      let data = response;
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateEvents(eventData) {
  return axios
    .post(endpoints.calendar.addUpdateEvent, eventData)
    .then(response => {
      let data = response;
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function deleteUserEvent(eventId) {
  return axios
    .delete(`${endpoints.calendar.deleteEvent}${eventId}`)
    .then(response => {
      let data = response;
      return data;
    })
    .catch(error => {
      return null;
    });
}

// async function getEmails(userId, nextLink = null) {
//   let url = `${endpoints.email.getEmail}${userId}&pageSize=10`;

//   // Only add nextPageLink if it's provided and not null
//   if (nextLink !== null && nextLink !== "") {
//     url += `&nextPageLink=${nextLink}`;
//   }

//   return axios
//     .get(url)
//     .then(response => {
//       let data = response;
//       return data;
//     })
//     .catch(error => {
//       console.error("API Error:", error.response?.data || error.message);
//       return null;
//     });
// }

async function getEmails(
  userId,
  cursorDate = "",
  cursorId = "",
  direction = "",
  pageNumber = 1,
) {
  return axios
    .get(
      `${endpoints.email.getEmail}${userId}&pageSize=10&cursorDate=${cursorDate}&cursorId=${cursorId}&direction=${direction}&pageNumber=${pageNumber}`,
    )
    .then(response => {
      let data = response;
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function sendEmail(data) {
  const payload = new FormData();
  payload.append("Subject", data.subject || "");
  payload.append("Body", data.body || "");
  payload.append("MessageId", data.messageId || "");
  payload.append("replyAll", data.replyAll || false);

  if (
    data.toEmails &&
    Array.isArray(data.toEmails) &&
    data.toEmails.length > 0
  ) {
    data.toEmails.forEach(file => {
      payload.append("ToEmails", file);
    });
  } else {
    payload.append("ToEmails", data.toEmails || []);
  }

  if (
    data.attachments &&
    Array.isArray(data.attachments) &&
    data.attachments.length > 0
  ) {
    data.attachments.forEach(file => {
      payload.append("Attachments", file.file);
    });
  }
  const token = localStorage.getItem("backend_api_token");
  return apiCall({
    url: `${endpoints.email.sendEmail}`,
    method: "post",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => response)
    .catch(error => {
      console.error("error : ", error);
      return null;
    });
}

async function getUserTeamAvailability(usersEmail) {
  return axios({
    method: "post",
    url: endpoints.calendar.getUserTeamAvailability,
    data: usersEmail,
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Full error:", error.response?.data || error);
      return null;
    });
}

export const dashboardApi = {
  getUserEvents: getUserEvents,
  addUpdateEvents: addUpdateEvents,
  deleteUserEvent: deleteUserEvent,
  getEmails: getEmails,
  sendEmail: sendEmail,
  getUserTeamAvailability: getUserTeamAvailability,
};
